import { FullStory, init } from '@fullstory/browser';
import type { TSdk } from '#observability/observability.types.ts';
import type { TFullStoryOptions } from './fullStory.types.ts';

const fullStorySdk: TSdk = {
  identify: ({ userId, traits }) =>
    FullStory('setIdentity', { uid: userId, properties: traits }),
  anonymize: () => FullStory('setIdentity', { anonymous: true }),
  track: (name, properties = {}) =>
    FullStory('trackEvent', { name, properties }),
};

export const initFullStory = ({ orgId }: TFullStoryOptions): TSdk => {
  init({ orgId });

  return fullStorySdk;
};
